const divFormEquipServType = {
  text: 'Próximos Vencimientos (No obligatorio):'
};

export default divFormEquipServType;
